import React from 'react';
import { Breadcrumb } from '@/components/ui/Breadcrumb';
import { MiniAssessment } from '@/components/mini-assessment/MiniAssessment';

export const MiniAssessmentPage = () => {
  return (
    <main className="pt-32 pb-24 bg-ground min-h-screen flex flex-col items-center">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full mb-8">
        <Breadcrumb items={[{ label: 'Free Mini Assessment' }]} />
      </div>
      <div className="flex-1 flex items-center justify-center w-full">
        <MiniAssessment />
      </div>
    </main>
  );
};

export default MiniAssessmentPage;
